export default __webpack_public_path__ + "static/media/totimelo.61a7eafb.jpeg";